import React, { useContext, useState, useEffect, useCallback } from 'react';
import { Icon, Menu, Dropdown, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { AppStoreContext } from '../../context/appStoreContext';
import URL from '../../utils/helper';
import { dayConversion, monthConversion } from '../../utils/javascript';
import { DOCUMENT_TEMPLATES_LIST } from './translationValues';
import {
  TemplatePageOverview,
  TemplateImage,
  DropdownDetails,
} from './styles';

const THUMBNAIL_KEY = 'thumbnail';
const NAMESPACES = ['DOCUMENT_TEMPLATES_LIST'];

const generateThumbnailUrl = (documentId) => `${URL.DESIGN_SYSTEM_URL}dynamic/thumbnail/${documentId}`;

const DocumentTemplate = props => {
  const { t } = useTranslation(NAMESPACES);
  const { templateObj, categoriesTemp, languageList, redirectToTemplate, enableModalVisibility } = props;
  const [firstPageImageLink, setFirstPageImageLink] = useState(templateObj[THUMBNAIL_KEY] ? templateObj[THUMBNAIL_KEY] : undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!templateObj[THUMBNAIL_KEY]) {
      setLoading(true);
      setFirstPageImageLink(generateThumbnailUrl(templateObj.id));
    }
  }, [templateObj]);

  const onImageError = useCallback(() => {
    setFirstPageImageLink(undefined);
    setLoading(false);
  }, []);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, []);

  let categoryByTemplate = {
    id: templateObj.id,
    name: templateObj.name,
    categoryId: templateObj.categoryId,
    type: templateObj.type,
  };

  return (
    <div key={templateObj.id}>
      <div className="test">
        <TemplatePageOverview
          key={templateObj.id}
          title={templateObj.name}
          onClick={() => redirectToTemplate(templateObj)}
        >
          <TemplateImage className={loading ? 'show-loader' : ''}>
            <div className="image-wrapper">
              <div key={templateObj.categoryId} className="preview-image-div">
                <img
                  src={firstPageImageLink ? firstPageImageLink : PageNotFoundIllustration}
                  alt="pageObj-thumbnail"
                  className={!firstPageImageLink ? 'no-thumbnail' : ''}
                  onError={onImageError}
                  onLoad={onLoad}
                />
              </div>
            </div>
            <DropdownDetails
              id={`${templateObj.id}-template`}
              className="dropdown-menu"
              onClick={e => e.stopPropagation()}
            >
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="0"
                      onClick={() => redirectToTemplate(templateObj)}
                    >
                      {t(
                        DOCUMENT_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.key,
                        DOCUMENT_TEMPLATES_LIST.EDIT_TEMPLATE_DROPDOWN_OPTION.value,
                      )}
                    </Menu.Item>
                    <Menu.Item
                      key="1"
                      onClick={() =>
                        enableModalVisibility('delete-template', categoryByTemplate)
                      }
                    >
                      {t(
                        DOCUMENT_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION.key,
                        DOCUMENT_TEMPLATES_LIST.DELETE_TEMPLATE_DROPDOWN_OPTION
                          .value,
                      )}
                    </Menu.Item>
                  </Menu>
                }
                trigger={['click']}
                getPopupContainer={() =>
                  document.getElementById(`${templateObj.id}-template`)
                }
              >
                <Icon type="more" />
              </Dropdown>
            </DropdownDetails>
          </TemplateImage>
          <div className="template_name">
            <div className="name" onClick={() => redirectToTemplate(templateObj)}>
              {templateObj.name}{' '}
            </div>
            <div className="categoryName">
              <div className="box2"></div>
              {categoriesTemp.length > 0 &&
                categoriesTemp.map(category => (
                  <div key={category.categoryId}>
                    {templateObj.categoryId === category.categoryId &&
                      category.categoryName}
                  </div>
                ))}
                {templateObj?.language && (
                  <Tooltip title={languageList?.find(ln => ln.code === templateObj?.language)?.name} trigger="hover">
                    <div className="language-tag">{templateObj?.language}</div>
                  </Tooltip>
                )}
            </div>

            {(templateObj.updatedOn || templateObj.createdOn) && (
              <div className="template_date">
                <p>
                  {templateObj.updatedOn
                    ? dayConversion(templateObj.updatedOn)
                    : dayConversion(templateObj.createdOn)}
                </p>
                <p className="month">
                  {templateObj.updatedOn
                    ? monthConversion(templateObj.updatedOn)
                    : monthConversion(templateObj.createdOn)}
                </p>
              </div>
            )}
          </div>
        </TemplatePageOverview>
      </div>
    </div>
  );
}

export default DocumentTemplate;